import axios from "axios";
import React, {Component} from "react";
import Listprint from "../../Listprint";

class   Repport extends Component{

    state = {
        isModal : false,
        formData : null,
        date_end : null,
        monthId : "",
        borrows : [],
        months : [],
    }

    componentDidMount(){
        
        var commitment_date = new Date();
        commitment_date = commitment_date.getMonth() + 1;
        this.setState({
            monthId : commitment_date
        })
        this.getMonths();
        this.getBorrows(commitment_date);
    }


    async getBorrows(monthId){
        this.setState({ borrows : [] })
        var borrows = await axios.get('borrowreports/'+monthId);
        if(borrows.status === 200)
        {
            this.setState({borrows : borrows.data}) 
        }
    }

    async getMonths(){
        var months = await axios.get("months");
        if(months.status === 200)
        {
            this.setState({
                months : months.data
            })
        }
    }


    handleInput = (e) => {
        this.getBorrows(e.target.value);
        this.setState({
            [e.target.name]: e.target.value
        }); 
    }

  handleCheck(val) {
    var permissions = localStorage.getItem("permissions") ? JSON.parse(localStorage.getItem("permissions")) : [];
     return  permissions.some(item => val === item.permission);
 }

    render(){
        var rows = [], columns = [
            {
                label: 'Livre',
                field: 'book',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Référence',
                field: 'reference',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Emplacement',
                field: 'spot',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Auteur',
                field: 'author',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Demandeur',
                field: 'user',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Date demande',
                field: 'date_start',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Date remise',
                field: 'date_end',
                sort: 'asc',
                width: 50
            },
            {
                label: 'Remis',
                field: 'status',
                sort: 'asc',
                width: 50
            },
        ];
        this.state.borrows.map((borrow) => {

            var author = "", nationality = "";
            borrow.book.authorbooks.map(authorbook => {
                author += authorbook.author.last_name + " " + authorbook.author.first_name + " , ";
                nationality += authorbook.author.nationality + " , ";
            });

            var date_start = new Date(borrow.date_start);
                date_start = date_start.getDate() + "-" + (date_start.getMonth()  + 1) + "-" + date_start.getFullYear();
            
            var date_end = new Date(borrow.date_end);
                date_end = date_end.getDate() + "-" + (date_end.getMonth()  + 1) + "-" + date_end.getFullYear();
                                                                
            rows.push({
                book : borrow.book.title,
                reference : borrow.book.spot.reference,
                spot : borrow.book.spot.spot,
                author : author,
                user : borrow.student ? borrow.student.matricule + " " + borrow.student.user.last_name + " " + borrow.student.user.family_name + " (élève)" : borrow.staff.matricule + " " + borrow.staff.user.last_name + " " + borrow.staff.user.first_name + " (Personnel)",
                date_start : date_start,
                date_end : date_end,
                status : borrow.status == 1 ? "Oui" : "Non",
                
            })
        })
        return(
            <div>
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
                <h5 className="h5 font-monospace">Rapport des emprunts des livres</h5>
                
            </div>
            <div className="text-end">
                <select name="monthId" value={ this.state.monthId} className="me-2 text-primary" onChange={this.handleInput}>
                    {
                        this.state.months.map((month) => {
                            return(
                                <option value={month.id}>{ month.month }</option>
                            )
                        })
                    }
                </select>
            </div>
            

            <div className="card shadow mb-2">
                <div className="card-body">
                    <div className="row overflow-auto mt-2">
                        {
                            rows.length > 0 && (
                                <Listprint columns={columns} rows={rows} title={"Rapport des emprunts des livres"}/>
                            )
                        }
                    </div>
                </div>
            </div>


        </div>
        )
    }
}
export default Repport;
